import Tag from '@/modules/tag'
import Consent from './consent'
import Api from '../api'


export default {

    setPage: function (vue, page, meta = true, value) {

        if (meta) {

            vue.$store.dispatch('setPage', page)
        }
        Tag.pageViewAmplitude(vue, page, null, value)
    },

    // Used only from the magic link form
    getLoginPathPostMagicForm: function ({provider, isOAuth}) {
        return buildLoginPathUsingProvider({provider, isOAuth})
    },

    // Take into account invalidGrant to false in order to return /magic-request-email
    getLoginPathUsingProviderAndInvalidGrant: function ({provider, invalidGrant, isOAuth}) {
        return invalidGrant === false
            ? '/magic-request-email'
            : buildLoginPathUsingProvider({provider, isOAuth})
    },

    getProvider(email) {
        return Api.provider.get(email)
            .then(data => {
                Consent.startLoginConsentFlow(email, data)
                return data
            })
    }

}

// Private

function buildLoginPathUsingProvider({provider, isOAuth}) {
    return ((isOAuth) ? '/login-o-auth' : '/login') + `/${provider}`
}
